import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { InvoiceStatusEnum } from 'src/app/shared/enums/invoice/invoice.enum';
import { countryType, currencyType, PaymentFee, PaymentType } from 'src/app/shared/enums/payment/payment.enum';
import { JustiFiPaymentMethod, JustiFiPaymentRequest, JustiFiPaymentRequestModel, MakePayLoad, PaymentMethod, PaymentRequestDTO, PaymentRequestModel, PaymentToken } from 'src/app/shared/interfaces/payment/payment.interface';
import { AddressFormatPipe } from 'src/app/shared/pipes/address-format.pipe';
import { API_ENDPOINTS, API_URL } from 'src/app/shared/utils/globals';
import { ProjulRegex } from 'src/app/shared/utils/regex';
import { decimal2, NumberUtil } from 'src/app/shared/utils/util-function';
import { ApiHandlerService } from '../api-handler.service';
import { parsePhoneNumber } from 'libphonenumber-js';

@Injectable({
  providedIn: 'root'
})
export class JustiFiService {

  constructor(private apiHandler: ApiHandlerService) { }

  async payCheckOut(pay: JustiFiPaymentRequestModel) {
    return (await lastValueFrom(this.apiHandler.Post(API_URL + API_ENDPOINTS.JustFiCheckOutPayment, pay)));
  }

  getFees(amount_Value: number, feeObj: any, isAch: boolean = false, isPartial: boolean = false) {
    const fees = { cCFee: 0, aCHFee: 0, };
    let amount = NumberUtil.ToNumber(amount_Value)
    if (amount) {
      if (isAch) {
        fees.aCHFee = Math.max((amount || 0) * (decimal2(feeObj.ACH.Value || 0) / 100));

        if (fees.aCHFee < feeObj.ACH.Min)
          fees.aCHFee = feeObj.ACH.Min;
        if (fees.aCHFee > feeObj.ACH.Max)
          fees.aCHFee = feeObj.ACH.Max;

        fees.aCHFee = decimal2(fees.aCHFee);
      } else {
        fees.cCFee = decimal2((amount || 0) * ((feeObj.CC.Value || 0) / 100));
      }
    }
    return fees;
  };

  generateCreditCardForm() {
    return new FormGroup({
      Name: new FormControl('', [Validators.required]),
      Email: new FormControl('', [Validators.required, Validators.pattern(ProjulRegex.email)]),
      PostalCode: new FormControl('', [Validators.required, Validators.pattern(ProjulRegex.postalCodeFormat)]) // Validators.pattern(ProjulRegex.postalCodeFormat)

    })
  }


  generateACHForm() {
    return new FormGroup({
      Name: new FormControl('', [Validators.required]),
      Email: new FormControl('', [Validators.required, Validators.pattern(ProjulRegex.email)]),
    })
  }

  // formate Phone Number 
  formatNumberForPreivew(phoneNo: any) {
    try {
      const phoneNumber = parsePhoneNumber(phoneNo, 'US')
      return phoneNumber.formatNational()
    }
    catch {
      return phoneNo
    }
  }

  payLoad(data: MakePayLoad) {
    
    let paymentObj = {} as JustiFiPaymentRequestModel;

    paymentObj.callBackUrl = window.location.href;
    paymentObj.sub_account_id = data.JustiFiOnboardingSettings?.Account?.id;
    paymentObj.portalurl_id = data.invoice.UrlId;
    paymentObj.invoice_id = data.invoice.Item?.Id;
    paymentObj.companyName = data.invoice?.Item?.CompanyName;
    paymentObj.companyLogo = data.invoice?.Item?.companyLogo;
    paymentObj.formatedCompanyNumber = this.formatNumberForPreivew(data.invoice?.Item?.CompanyPhoneNo);
    paymentObj.companyNumber = data.invoice?.Item?.CompanyPhoneNo;
    paymentObj.companyEmail = data.invoice?.Item?.CompanyEmail;
    paymentObj.companyAddress = new AddressFormatPipe().transform(data.invoice?.Item?.CompanyAddress);
    paymentObj.name = data.forms.Name;

    paymentObj.is_card = data.Type === PaymentType.CreditCard ? true : false
    paymentObj.invoice_number = data.invoice.Item?.InvoiceNumber || null;

    paymentObj.payment_date = new Date();

    data.remainingBlc ||= 0;

    if (data.Type == PaymentType.CreditCard) {
      paymentObj.fee = data.cardProcessingFee || 0;
      paymentObj.companyPaysFee = data.invoice.Item.CreditCardFee === PaymentFee.Company;

      if (data.remainingBlc > 0)
        paymentObj.status = InvoiceStatusEnum.Partial;
      else if (data.remainingBlc <= 0)
        paymentObj.status = InvoiceStatusEnum.Paid
      else
        paymentObj.status = data.invoice.Item.Status
    }

    if (data.Type == PaymentType.ACH) {
      paymentObj.fee = data.achProcessingFee || 0;
      paymentObj.companyPaysFee = data.invoice.Item.AchFee === PaymentFee.Company;

      if (data.remainingBlc > 0)
        paymentObj.status = InvoiceStatusEnum.Partial;
      else if (data.remainingBlc <= 0)
        paymentObj.status = InvoiceStatusEnum.Paid
      else
        paymentObj.status = data.invoice.Item.Status
    }

    paymentObj.payment_request = {} as JustiFiPaymentRequest
    let amountInCent = decimal2(data.PaymentTotal) * 100;
    amountInCent = decimal2(amountInCent);
    paymentObj.payment_request.amount = Math.ceil(amountInCent);
    paymentObj.payment_request.currency = (data.JustiFiOnboardingSettings?.Country == countryType.CA ? currencyType.CAD : currencyType.USD).toLowerCase();
    paymentObj.payment_request.email = data.forms?.Email;
    paymentObj.payment_request.capture_strategy = data.capture_strategy;

    paymentObj.payment_request.payment_method = {} as JustiFiPaymentMethod;
    if (data.Type == PaymentType.ACH) {
      paymentObj.payment_request.payment_method.token = data.responseAPI.data.bank_account.token;
      paymentObj.billed_to_type = data.responseAPI.data.bank_account.account_type;
      paymentObj.billed_to = 'xxxxxx' + data.responseAPI.data.bank_account.acct_last_four;
    }
    else {
      paymentObj.payment_request.payment_method.token = data.responseAPI.data.card.token;
      paymentObj.billed_to_type = data.responseAPI.data.card.brand;
      paymentObj.billed_to = 'xxxxxx' + data.responseAPI.data.card.acct_last_four;
    }

    return paymentObj
  }

  AddressToString(address: any) {
    let formattedAddress: string;
    formattedAddress = address ?
      (address["line1"] ? (address["line1"] + ((address["line2"] === '' && address["state"]) ? ", " : " ")) : "")
      + (address["line2"] ? (address["line2"] + (address["state"] ? ", " : " ")) : "")
      + (address["state"] ? (address["state"] + (address["city"] ? ", " : " ")) : "")
      + (address["city"] ? (address["city"] + (address["postal_code"] ? ", " : " ")) : "")
      + (address["postal_code"] ? (address["postal_code"] + (address["country"] ? ", " : " ")) : "")
      + (address["country"] ? address["country"] : "") : "";
    return formattedAddress;
  }
}
